const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);

const MODIFIER_SYMBOLS: Record<string, { mac: string; other: string }> = {
  $mod: { mac: "\u2318", other: "Ctrl" },
  Control: { mac: "\u2303", other: "Ctrl" },
  Alt: { mac: "\u2325", other: "Alt" },
  Shift: { mac: "\u21E7", other: "Shift" },
  Meta: { mac: "\u2318", other: "Win" },
};

const KEY_SYMBOLS: Record<string, string> = {
  Enter: "\u23CE",
  Backspace: "\u232B",
  Delete: "\u2326",
  Escape: "Esc",
  ArrowUp: "\u2191",
  ArrowDown: "\u2193",
  ArrowLeft: "\u2190",
  ArrowRight: "\u2192",
  " ": "Space",
};

/**
 * Converts a single tinykeys binding string into an array of display tokens.
 *
 * @example
 * formatShortcut("$mod+k")       // macOS: ["⌘", "K"]   Windows: ["Ctrl", "K"]
 * formatShortcut("$mod+Shift+p") // macOS: ["⌘", "⇧", "P"]
 * formatShortcut("g d")          // ["G", "D"]
 */
export const formatShortcut = (binding: string): string[] => {
  const presses = binding.split(" ");

  if (presses.length > 1) {
    return presses.map((p) => p.toUpperCase());
  }

  const press = presses[0];
  if (!press) return [];
  const parts = press.split("+");
  return parts.map((part) => {
    const mod = MODIFIER_SYMBOLS[part];
    if (mod) return isMac ? mod.mac : mod.other;
    return KEY_SYMBOLS[part] ?? part.toUpperCase();
  });
};

/** True when the current platform is macOS / iOS. */
export const isPlatformMac = () => isMac;
